import React from 'react';

const NotFound = props => {
    return (
        <div>
            <p>Usj, denne siden fant vi ikke.</p>
        </div>
    );
};

export default NotFound;